module.exports = __webpack_public_path__ + "img/nerd_face.ccfb4419.gif";